import React from "react";
import { render } from 'react-dom';
import Routes from './app/Routes.js';

render(
  <Routes />,
  document.getElementById("root")
);
